import {
  ProductList,
  ProductListProps,
} from "@made-people/blueprint-product-list";
import { withManagedProps } from "@made-people/managed-props";
import { RandomizedSearchResultItems } from "./randomized-search-result-items";

/**
 * In this file you can specify default props for components that render,
 * which have been wrapped with withManagedProps
 */

export const RandomizedProductList = withManagedProps(
  "RandomizedProductList",
  (props: ProductListProps) => {
    return (
      <RandomizedSearchResultItems>
        <ProductList {...props} />
      </RandomizedSearchResultItems>
    );
  },
);
